import { withExtraArgument } from 'redux-thunk';
import {
  api as apiMiddleware,
  notifyDirectors,
  programEmitter,
  programSceneLayerUpdater,
  updateProgramByCameraStatus,
  sessionStateEmitter,
  attendeeRosterEmitter,
  rejectedKnockMiddleware,
  streamRecordStatus,
  updateSourceChangesToProgram,
  notification,
  dataDog as dataDogMiddleware,
  showAPIError,
  updateProgramLayers,
  presentationControlNotifier,
  sourceUpdateStatusManager,
  setSourceInitializing,
  actionDebugger,
  videoPriorityBasedPolicyMiddleware,
  chimeMetricsOnstageAttendeeUpdaterMiddleware,
  toggleBackgroundHiddenMiddleware
} from '@shoflo/studio-redux/middleware';
import { getEnvVar } from '@shoflo/polymer';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';

import {
  acceptedKnockMiddleware,
  bulkAcceptedKnockMiddleware,
  createdBackgroundMiddleware,
  updateBackgroundOnProgramStartMiddleware,
  notifyDirectors as localNotifyDirectors,
  joinMeetingMiddleware
} from 'middleware';
import createRootReducer from 'reducers';
import { setProgram } from 'actions/program';
import SocketDispatcher from './SocketDispatcher';

function createConfiguredStore() {
  const socketDispatcher = new SocketDispatcher();
  const socket = socketDispatcher.connect();

  const history = createBrowserHistory();

  const initialState = {};

  const enhancers = [];

  const middleware = [
    withExtraArgument(socket),
    routerMiddleware(history),
    apiMiddleware,
    localNotifyDirectors(socket),
    notifyDirectors(socket),
    acceptedKnockMiddleware(socket),
    bulkAcceptedKnockMiddleware(socket),
    programEmitter(socket),
    sessionStateEmitter(socket),
    attendeeRosterEmitter(socket),
    programSceneLayerUpdater(setProgram),
    updateProgramByCameraStatus(setProgram),
    createdBackgroundMiddleware(),
    updateProgramLayers(),
    updateBackgroundOnProgramStartMiddleware(),
    rejectedKnockMiddleware(socket),
    streamRecordStatus(socket),
    updateSourceChangesToProgram(setProgram),
    dataDogMiddleware,
    notification,
    showAPIError,
    presentationControlNotifier(),
    sourceUpdateStatusManager(),
    setSourceInitializing,
    videoPriorityBasedPolicyMiddleware,
    chimeMetricsOnstageAttendeeUpdaterMiddleware,
    joinMeetingMiddleware,
    toggleBackgroundHiddenMiddleware(),
    actionDebugger // this should be the last middleware
  ];

  if (getEnvVar('NODE_ENV') === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const store = createStore(
    createRootReducer(history),
    initialState,
    composedEnhancers
  );

  socketDispatcher.bindToStore(store);

  return {
    store,
    history
  };
}

const { store, history } = createConfiguredStore();

export { store, history };

export { createConfiguredStore };
